const {loadAnimation} = require("../utils/cache-animation");

module.exports = function () {
    const tabsContent = document.querySelectorAll(".tab-content");
    if ( !tabsContent.length ) return;
    let lottiePlayer = null;
    
    for (const tabContent of tabsContent) {
        const tabs = tabContent.querySelectorAll(".tab");
        const contents = tabContent.querySelectorAll(".content");
        let currentIndex = 0;

        const observer = new IntersectionObserver(async (entries) => {
            for (const entry of entries) {
                if ( entry.isIntersecting ) {
                    lottiePlayer = await import("@lottiefiles/lottie-player");
                    await setTab(currentIndex);
                    observer.disconnect();
                }
            }
        })

        observer.observe(tabContent);
        
        // init
        setTab(currentIndex);
        
        async function setTab(index) {
            currentIndex = index;
            
            tabs?.forEach(t => t.classList.remove("active"));
            contents?.forEach(c => c.classList.remove("active"));

            tabs[index]?.classList.add("active");
            contents[index]?.classList.add("active");
            
            const player = contents[index].querySelector("lottie-player");

            if ( player && lottiePlayer !== null ) {
                const animation = await loadAnimation(player.dataset.src);
                player.load(animation);
                player.play();
            }
        }
        
        tabs.forEach((tab, index) => {
            tab.addEventListener("click",  () => {
                if ( currentIndex !== index ) setTab(index);
            })
        })
    }
}